import { proxyBlobContainer } from '../utils/env';

const onLoadDelay = 2000
const TenantStyleSheetId = 'data-tenant-styles'

export const getDomElement = <T>(selector: string): T | null => {
  return document.querySelector(selector) as T | null;
}

export function findAllInDom <T extends Element>(selector: string) {  
  return document.querySelectorAll(selector) as NodeListOf<T>
}

export function createStylesheet(href: string, onLoad: () => void, onError: () => void) {
  findAllInDom(`[${TenantStyleSheetId}]`).forEach((e) => e.remove())
  const link = document.createElement('link');

  link.rel = 'stylesheet';
  link.href = proxyBlobContainer(href);
  link.setAttribute('data-tenant-styles', Date.now().toString());

  link.onerror = () => {
    console.error('Error loading tenant styles from URL:', href);
    onError();
  };

  document.head.appendChild(link);
  setTimeout(onLoad, onLoadDelay)
}

export const getTargetAttr = (target: HTMLElement, selector: string): string | undefined | null => {
  return target.getAttribute(selector);
}

export const getTargetElm = (target: HTMLElement, selector: string): HTMLElement | undefined | null => {
  return target.querySelector<HTMLElement>(selector);
}

export const toggleClass = (target: HTMLElement, cls: string, add: boolean): void => {
  target.classList[add ? 'add' : 'remove'](cls);
}
